import { KeyboardDatePicker } from '@material-ui/pickers';
import moment from 'moment';
import { useStyledFieldStyles } from './useStyledFieldStyles';

interface Props {
  value: string | null;
  onChange: (value: string | null) => void;
  onBlur?: () => void;
  minDate?: string | null;
  placeholder?: string;
}

const StyledDatePicker = ({
  value,
  onChange,
  onBlur,
  minDate,
  placeholder
}: Props) => {
  const classes = useStyledFieldStyles();

  return (
    <KeyboardDatePicker
      autoOk
      clearable
      variant="inline"
      inputVariant="outlined"
      format="DD/MM/YYYY"
      placeholder={placeholder ?? 'dd/mm/aaaa'}
      value={value ? moment(value, 'YYYY-MM-DD') : null}
      onChange={(date) =>
        onChange(date && date.isValid() ? date.format('YYYY-MM-DD') : null)
      }
      onBlur={onBlur}
      minDate={minDate ? moment(minDate, 'YYYY-MM-DD') : undefined}
      className={classes.field}
      KeyboardButtonProps={{ size: 'small' }}
    />
  );
};

export default StyledDatePicker;
